module.exports = __webpack_public_path__ + "img/qnb_finansbank_logo.a6404562.svg";